import CodeMirror from "@uiw/react-codemirror";
import styled from "styled-components";

import { primary } from "@formant/ui/component/common/Colors";
import { Typography } from "@formant/ui/component/common/Typography";

import { IconButton } from "../../common/IconButton";
import { Popup } from "../../common/Popup";
import { Scrollable } from "../../common/Scrollable";
import { StandardButton } from "../../common/StandardButton";
import { TabButtons } from "../../common/Tabs/TabButtons";

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
    margin-bottom: 1rem;
`;

export const Label = styled(Typography)<{ type: string }>`
    margin-left: 0.625rem;
`;

export const Heading = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 0.25rem;
    margin-left: 0.25rem;
    margin-bottom: 10px;
`;

export const UpdateAiSqlButton = styled(StandardButton)`
    margin-left: 1rem;
`;

export const ExpandButton = styled(IconButton)`
    padding: 0.425rem;
    padding-top: 0.3rem;
    border-radius: 1rem;
    &:hover {
        background: ${primary.steel01};
        padding-top: 0.3rem;
    }
`;

export const DocTooltipContainer = styled.div`
    color: ${primary.silver};
    background-color: ${primary.flagship} !important;
`;

export const FormContainer = styled.div`
    padding-top: 1rem;
    padding-left: 1rem;
    .ace_content {
    }

    .ace-one-dark {
        background-color: ${primary.module};
        font-weight: 600;
    }

    .ace_editor.ace_autocomplete {
        background-color: ${primary.module} !important;
        color: ${primary.white} !important;
    }

    & .ace_tooltip .ace_dark {
        background-color: ${primary.module} !important;
        color: ${primary.white} !important;
    }

    & .ace_active-line {
        background-color: ${primary.module} !important;
        background: unset !important;
    }

    & .w-tc-editor {
        --color-prettylights-syntax-keyword: var(
            --formant-color-highlights-blue
        );
        --color-prettylights-syntax-sublimelinter-gutter-mark: var(
            --formant-color-primary-silver
        );
        --color-fg-default: var(--formant-color-primary-white);
    }

    textarea {
        resize: none;
    }

    .error-marker {
        border-bottom: 1px solid red;
        position: absolute;
    }
`;

export const SideContainer = styled(FormContainer)`
    width: 17.5rem;
`;

export const SendContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    button {
        margin-left: -2.5rem;
    }
    span {
        width: 100%;
        border-bottom: none;
    }
    textarea {
        padding-right: 2rem;
        min-height: 6.25rem;
        background: ${primary.module} !important;
        border-style: none;
        border-color: Transparent;
        overflow: auto;
        resize: none;
    }
`;

export const Mirror = styled(CodeMirror)`
    font-family: "Moderat" !important;
    font-style: normal;
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    letter-spacing: 0.6px;
    background-color: ${primary.module} !important;
    box-shadow: inset 0px -0.0625rem 0px ${primary.steel03} !important;
    min-height: 18.75rem;

    .cm-scroller {
        min-height: 18.75rem;
    }

    .cm-editor {
        max-width: 18.75rem;
        background-color: ${primary.module} !important;
    }
`;

export const Header = styled(Typography)<{ type: string }>`
    margin-top: 1.875rem;
    margin-left: 0.625rem;
    display: inline-block;
`;

export const SmallFormContainer = styled.div`
    padding: 2rem;
    padding-top: 0rem;

    select {
        max-width: 18.5rem;
    }

    a {
        vertical-align: unset;
    }
`;

export const TabsContainer = styled(TabButtons)`
    margin-top: 1.875rem;
    display: flex;
    flex: 1;
    justify-content: space-around;
`;

export const SqlEditorForm = styled.div`
    display: flex;
    justify-content: center;
    padding-bottom: 1rem;
`;

export const WideButton = styled(StandardButton)`
    width: 95%;
`;

export const AdvancedContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: 1rem;
`;

export const Spacer = styled.div`
    margin-top: 3.5rem;
`;

export const AiContent = styled.div`
    margin-bottom: 2px;
`;

export const ExpandedContainer = styled.div`
    display: flex;
    flex-direction: row;

    & .cm-editor {
        max-width: 25rem;
    }
`;

export const SubContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow-x: hidden;
`;

export const ErrorContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 12.625rem;
    min-width: 50rem;
    background-color: ${primary.steel01};
`;

export const TableContainer = styled.div`
    min-width: 50rem;
    max-width: 50rem;
    overflow: auto;
`;

export const HalfExpandedContainer = styled.div`
    min-width: 50%;
`;

export const HalfExpandedLeftContainer = styled(Scrollable)`
    border-top: 1px solid ${primary.flagship};
    border-right: 1px solid ${primary.flagship};
    min-width: 50%;

    .cm-theme {
        min-height: 18.75rem;
        box-shadow: none;
    }

    .cm-scroller {
        min-height: 18.75rem;
    }
`;

export const HalfExpandedRightContainer = styled.div`
    border-left: 1px solid ${primary.flagship};
    border-top: 1px solid ${primary.flagship};
    min-width: 50%;
    max-width: 50%;
    div[class^="button-container_"] {
        background: ${primary.module};
    }

    overflow-x: hidden;
    .cm-theme {
        min-height: 18.25rem;
    }
`;

export const PopupWrapper = styled(Popup)`
    .invalidate {
        padding: 0rem;
        margin: 0rem;
        height: 100%;
    }
`;

export const ButtonBar = styled.div`
    height: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${primary.flagship};

    button {
        margin: 0.625rem;
    }

    span {
        margin-left: 0.925rem;
    }
`;
